import { Title } from '@winnin/winnin_ui.components.title'

import { ReactComponent as EmptyNiche } from 'assets/images/svg/topics/empty-niche.svg'
import { Button } from 'components/Button'
import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import TOLGEE_KEYS from './niche-error.i18n'
import type { INicheError } from './niche-error.types'

import './niche-error.styles.scss'

export function NicheErrorView({ onRetry }: INicheError) {
  const t = useTranslate()

  return (
    <div className="ErrorStateNiches">
      <EmptyNiche />

      <div className="ErrorStateNiches-content">
        <Title tag="h3" weight="semi">
          {t(TOLGEE_KEYS.contextName)}
        </Title>
        <p>{t(TOLGEE_KEYS.contextNameDescription)}</p>

        <Button variant="outlined" onClick={onRetry}>
          <T keyName={TOLGEE_GLOBALS.tryAgain.key}>{TOLGEE_GLOBALS.tryAgain.defaultValue}</T>
        </Button>
      </div>
    </div>
  )
}
